export enum AestethicNutritionTypes {
  Standart = "Estándar",
  Sports = "Deportiva",
  Vegetarian = "Vegetariana",
  GlutenAndDairyFree = "Sin gluten ni lácteos",
  GlutenFree = "Sin gluten",
  DairyFree = "Sin lácteos",
  LowInCarbohydrates = "Baja en hidratos",
  LowInCarbohydrates2 = "Baja en hidratos 2",
}

export enum HypertrophyNutritionTypes {
  Standart = "Estándar",
  Sports = "Deportiva",
  Vegetarian = "Vegetariana",
  GlutenAndDairyFree = "Sin gluten ni lácteos",
  GlutenFree = "Sin gluten",
  LowInCarbohydrates = "Baja en hidratos",
  LowInCarbohydrates2 = "Baja en hidratos 2",
}

export enum DefinitionNutritionTypes {
  Standart = "Estándar",
  Sports = "Deportiva",
  Vegetarian = "Vegetariana",
  GlutenAndDairyFree = "Sin gluten ni lácteos",
  GlutenFree = "Sin gluten",
  DairyFree = "Sin lácteos",
  LowInCarbohydrates = "Baja en hidratos",
  LowInCarbohydrates2 = "Baja en hidratos 2",
}
